var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.photo)?_c('div',{staticClass:"photo-container"},[_c('img',{staticClass:"dragme",attrs:{"alt":"dragPhoto","src":_vm.imageUrl},on:{"mousedown":_vm.startDrag,"mouseup":_vm.stopDrag,"touchstart":_vm.startDrag,"touchend":_vm.stopDrag}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }